/* eslint-disable no-console */
/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ErrorPromptPayMe.css";
import PropTypes from "prop-types";
import { isMobile } from "react-device-detect";

class ErrorPromptPayMe extends Component {
  constructor(props) {
    super(props);
    try {
      this.state =
        this.props.location.state || JSON.parse(localStorage.getItem("state"));
    } catch (e) {
      this.props.history.push("/SelectMission");
    }
  }
  render() {
    try {
      const dataObj = this.state;
      const status = this.state.status || "error";
      const languageObj = this.props.t("ErrorPromptPayMe".toUpperCase(), {
        returnObjects: true,
      });
      var text = status === "error" ? languageObj.error : languageObj.expired;
      var cancelText =
        status === "error" ? "Choose Other Methods" : "Cancel Payment";
      var cancelLink =
        status === "error"
          ? {
            pathname: "/SelectPayment",
            state: dataObj,
          }
          : "/";
    } catch (e) {
      // console.error(e);
    }
    return (
      <div className="ErrorPromptPayMe-view">
        <div className="ErrorPromptPayMe-prompt">
          <div className="ErrorPromptPayMe-errorIcn"></div>
          <div className="ErrorPromptPayMe-text">{text}</div>
          <div
            className="ErrorPromptPayMe-closeBtn"
            onClick={() => {
              const dataObj = this.state;
              this.props.history.push({
                pathname: isMobile ? "/PayMeLink" : "/PayMeCode",
                state: dataObj,
              });
            }}
          ></div>
          <div
            className="ErrorPromptPayMe-closeBtn2"
            onClick={() => {
              this.props.history.push(cancelLink);
            }}
          >
            {cancelText}
          </div>
        </div>
      </div>
    );
  }
}
ErrorPromptPayMe.propTypes = {
  t: PropTypes.func,
};

export default ErrorPromptPayMe;
